<template>
  <div>
    <BaseHeader />
    <BaseLayout>
      <BaseBody>
        <template #main>
          <TextContainer align="center">
            <BaseHeading>Hoppla!</BaseHeading>
            <BaseHeading>Etwas ist schief gegangen.</BaseHeading>
            <Spacer :mt="6" />
            <BaseIllustration type="alert" size="big" />
            <Spacer :mt="5" />
            <BaseText type="bold">
              Wir helfen Ihnen auch telefonisch weiter:
            </BaseText>
            <BaseLink url="tel:034169700800">
              0341-697008-00
            </BaseLink>
            <Spacer :mt="3" />
            <BaseText>
              Montag bis Donnerstag von 9 - 17 Uhr und Freitag von 9 - 14 Uhr
            </BaseText>
          </TextContainer>
        </template>
      </BaseBody>
    </BaseLayout>
    <BaseFooter />
  </div>
</template>

<script setup lang="ts">
import Spacer from '~/base/components/spacer/Spacer.vue'
import BaseHeading from '~/base/components/heading/Heading.vue'
import BaseLink from '~/base/components/link/Link.vue'
import BaseText from '~/base/components/text/Text.vue'
import TextContainer from '~/base/components/textContainer/TextContainer.vue'
import BaseBody from '~/base/components/body/Body.vue'
import BaseLayout from '~/base/components/layout/Layout.vue'
import { definePageMeta } from '#imports'
import BaseFooter from '~/base/components/footer/Footer.vue'
import BaseHeader from '~/base/components/header/Header.vue'

definePageMeta({
  pageName: 'Allgemeiner Fehler',
  category: 'fehler',
  label: 'fehler-allgemeiner-fehler'
})
</script>
